import React from 'react';

export default () => (
  <svg
    width="21"
    height="14"
    viewBox="0 0 21 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Fill 1</title>
    <path
      d="M1.586 8h15.586l-4.293 4.293a.999.999 0 1 0 1.414 1.414l6-5.999v-.001L21 7l-.706-.707-.001-.001-6-5.999a.997.997 0 0 0-1.414 0 .999.999 0 0 0 0 1.414L17.172 6H1.586a1 1 0 0 0 0 2"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconArrowRight.jsx